<template>
    <input ref="inputElement" :name="name" type="text" class="form-control" />
</template>

<script setup lang="ts">
    import { TimePicker, type TimePickerOptions } from "@/portal/formControls/TimePicker";
    import { onMounted, ref, watch } from "vue";

    const model = defineModel<string | undefined>({ required: true });
    const props = defineProps<{
        name?: string;
        options?: TimePickerOptions;
    }>();

    const inputElement = ref<HTMLInputElement>();

    let component: TimePicker | undefined = undefined;
    onMounted(() => {
        component = new TimePicker($(inputElement.value!), props.options);
        component.onChange = () => {
            model.value = component?.getValue();
        };
        component.setValue(model.value);
    });

    watch(model, (value) => {
        component?.setValue(value);
    });

    function setError(hasError: boolean) {
        component?.setError(hasError);
    }

    defineExpose({
        setError,
    });
</script>
